import { InjectionToken } from '@angular/core';

export const ASSETS_PATH = new InjectionToken<string>('assetsPath');
